export default __webpack_public_path__ + "img/bellFilled.9cd7f6b8.svg";